const asanaTriggerDefaults = {
  workspaceGid: '',
  resourceType: 'project',
  resourceGid: '',
  pollMode: 'everyXMinutes',
  minuteInterval: 5,
  minute: 0,
  hour: 9,
  timezone: 'UTC',
  cronExpression: '*/5 * * * *',
};

export default asanaTriggerDefaults;
